"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Text_1 = __importDefault(require("./Text"));
const styles_1 = require("../styles");
const handleRightBorderColor = (activeIndex, index) => {
    if (index === 0) {
        return react_native_1.StyleSheet.flatten([valuesStyles.inactiveBorder, valuesStyles.fakeBorder]);
    }
    if (index <= activeIndex) {
        return react_native_1.StyleSheet.flatten([valuesStyles.inactiveBorder, valuesStyles.activeBorder]);
    }
    return valuesStyles.inactiveBorder;
};
const handleLeftBorderColor = (activeIndex, index, lastIndex) => {
    if (index === lastIndex) {
        return react_native_1.StyleSheet.flatten([valuesStyles.inactiveBorder, valuesStyles.fakeBorder]);
    }
    if (index < activeIndex) {
        return react_native_1.StyleSheet.flatten([valuesStyles.inactiveBorder, valuesStyles.activeBorder]);
    }
    return valuesStyles.inactiveBorder;
};
const handleCircleStyle = (activeIndex, index) => {
    if (index <= activeIndex) {
        return { backgroundColor: styles_1.Colors.primary };
    }
    return { backgroundColor: styles_1.Colors.placeholder };
};
const getSelectedValueIndex = (value, values = []) => {
    for (let i = 0; i < values.length; i++) {
        if (values[i] === value) {
            return i;
        }
    }
    return -1;
};
const Stop = ({ onPress, _selfIndex = 0, _activeIndex = 0, label = '', value = '', _numberOfStops = 0, }) => {
    return (react_1.default.createElement(react_native_1.View, { style: valuesStyles.container },
        react_1.default.createElement(react_native_1.View, { style: valuesStyles.circleAndLines },
            react_1.default.createElement(react_native_1.View, { style: handleRightBorderColor(_activeIndex, _selfIndex) }),
            react_1.default.createElement(react_native_1.Pressable, { style: react_native_1.StyleSheet.flatten([valuesStyles.circle, handleCircleStyle(_activeIndex, _selfIndex)]), onPress: () => {
                    onPress && onPress({ label, value });
                } }),
            react_1.default.createElement(react_native_1.View, { style: handleLeftBorderColor(_activeIndex, _selfIndex, _numberOfStops - 1) })),
        react_1.default.createElement(Text_1.default, { style: valuesStyles.label }, label)));
};
const valuesStyles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
    },
    inactiveBorder: {
        flex: 1,
        borderBottomWidth: 8,
        borderColor: styles_1.Colors.placeholder,
    },
    activeBorder: {
        borderColor: styles_1.Colors.primary,
    },
    fakeBorder: {
        borderColor: 'rgba(0, 0, 0, 0)',
    },
    circleAndLines: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    label: {
        alignSelf: 'center',
        marginBottom: 0,
    },
    circle: {
        width: 30,
        height: 30,
        borderRadius: 30,
    },
});
const handleRadiusValues = (values = [], activeIndex, onPress) => {
    return values.map((value, index) => {
        return (react_1.default.createElement(Stop, { key: `sliderValues${value.props.value}`, _selfIndex: index, _activeIndex: activeIndex, _numberOfStops: values.length, label: value.props.label, value: value.props.value, onPress: onPress }));
    });
};
const Slider = ({ children = [], selectedValue = '', onPress }) => {
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([
            styles.container,
            react_native_1.Platform.select({
                web: {
                    userSelect: 'none',
                },
            }),
        ]) }, handleRadiusValues(children, getSelectedValueIndex(selectedValue, children.map((value) => value.props.value)), onPress)));
};
Slider.Stop = Stop;
exports.default = Slider;
const styles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
});
